import api from '../config/api';
import { isApiEnabled } from '../config/appConfig';
import { getApiData, parseApiError } from './apiUtils';

const STORAGE_KEY = 'blf_donor_applications';

const initialState = {
  nombreCompleto: '',
  email: '',
  telefono: '',
  tipoDonacion: 'unica',
  donativo: 'corporativa',
  mensaje: '',
};

export const getDonorFormInitialState = () => ({ ...initialState });

const submitDonorApplicationLocal = (formData) => {
  const nombreCompleto = (formData.nombreCompleto || '').trim();
  const email = (formData.email || '').trim();
  const telefono = (formData.telefono || '').trim();
  const tipoDonacion = formData.tipoDonacion === 'recurrente' ? 'recurrente' : 'unica';
  const donativo = formData.donativo === 'monetaria' ? 'monetaria' : 'corporativa';
  const mensaje = (formData.mensaje || '').trim();

  if (!nombreCompleto) {
    return Promise.reject(new Error('El nombre completo es obligatorio.'));
  }

  if (!email) {
    return Promise.reject(new Error('El correo electrónico es obligatorio.'));
  }

  if (!telefono) {
    return Promise.reject(new Error('El teléfono es obligatorio.'));
  }

  const application = {
    id: Date.now(),
    nombre_completo: nombreCompleto,
    email,
    telefono,
    tipo_donacion: tipoDonacion,
    donativo,
    mensaje,
    estado: 'pendiente',
    creado_en: new Date().toISOString(),
  };

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const stored = raw ? JSON.parse(raw) : [];
    const updated = Array.isArray(stored) ? [application, ...stored] : [application];
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (error) {
    return Promise.reject(new Error('No se pudo guardar la solicitud de donación.'));
  }

  return Promise.resolve(application);
};

const validateDonorForm = (formData) => {
  const nombreCompleto = (formData.nombreCompleto || '').trim();
  const email = (formData.email || '').trim();
  const telefono = (formData.telefono || '').trim();

  if (!nombreCompleto) {
    throw new Error('El nombre completo es obligatorio.');
  }

  if (!email) {
    throw new Error('El correo electrónico es obligatorio.');
  }

  if (!telefono) {
    throw new Error('El teléfono es obligatorio.');
  }

  return {
    nombre_completo: nombreCompleto,
    email,
    telefono,
    tipo_donacion: formData.tipoDonacion === 'recurrente' ? 'recurrente' : 'unica',
    donativo: formData.donativo === 'monetaria' ? 'monetaria' : 'corporativa',
    mensaje: (formData.mensaje || '').trim(),
  };
};

export const submitDonorApplication = (formData) => {
  if (!isApiEnabled()) {
    return submitDonorApplicationLocal(formData);
  }

  let payload;

  try {
    payload = validateDonorForm(formData);
  } catch (error) {
    return Promise.reject(error);
  }

  return api
    .post('/donaciones_crear.php', payload)
    .then((response) => getApiData(response, 'No se pudo guardar la solicitud de donación.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};
